import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Tag } from '../../../app/app.interfaces';
import { ApiService } from "../../../services/api.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormHelper } from "../../../helpers/form.helper";
import { IonicHelper } from "../../../helpers/ionic.helper";

@Component({
	selector: 'admin-tag',
	templateUrl: 'admin-tag.html'
})

export class AdminTag implements OnInit {

	@Input() tag: Tag;
	@Output() tagChange: EventEmitter<Tag> = new EventEmitter<Tag>();
	@Output() tagRemove: EventEmitter<Tag> = new EventEmitter<Tag>();
	
	form: FormGroup;
	edit: boolean = false;

	constructor( private apiService: ApiService,
							 private ionic: IonicHelper,
							 private formBuilder: FormBuilder){
	}

	toggleEdit(show){
		if(show===undefined) this.edit = !this.edit;
		else this.edit=show;
	}

	ngOnInit(): void {
		this.buildForm();
	}

	buildForm(): void{
		this.form = this.formBuilder.group({
			title: [this.tag.title, Validators.compose([Validators.minLength(1), Validators.maxLength(60)])],
		});
	}

	submitForm(): void {

		this.ionic.toggleLoader(true);

		if(this.form.valid){

			let updatedTag = FormHelper.updateObjectWithFormValues(this.tag, this.form);

			this.apiService.updateResource(updatedTag).then((tag) => {

				this.tag = tag;
				this.tagChange.emit(this.tag);
				this.ionic.toggleLoader(false);
				this.ionic.toast('ADMIN.EDIT_TAGS.UPDATED_TOAST');
				this.edit = false;

			}).catch((err) => {
				console.error(err);
				this.ionic.toggleLoader(false);
				this.ionic.alert('GLOBAL.GENERAL_ERROR');
			});
		}
		else {
			this.ionic.toggleLoader(false);
			this.ionic.invalidFieldsAlert(
				'ADMIN.EDIT_TAGS.ERROR',
				'POST_CREATE.TRY_AGAIN',
				'ADMIN.EDIT_TAGS.ERRORS',
				FormHelper.getInvalidFormControls(this.form.controls)
			);
		}

	}

	deleteTag(){
		this.ionic.confirm('ADMIN.EDIT_TAGS.CONFIRM_DELETE_MSG', 'GLOBAL.ARE_YOU_SURE','GLOBAL.DELETE').subscribe((confirmed: boolean) => {
			if(confirmed){
				this.apiService.deleteResource(this.tag).then(()=>{

				  this.tagRemove.emit(this.tag);
				  this.ionic.toast('ADMIN.EDIT_TAGS.DELETED_TOAST');

				}).catch((err) => {
					console.error(err);
					this.ionic.alert('GLOBAL.GENERAL_ERROR');
				});

			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/partials/admin/admin-tag/admin-tag.ts